import React from "react";

export const UiDashboardWrapper = (props) => {
  return (
    <>
      <div className="df-dashboard-wrapper">{props.children}</div>
    </>
  );
};
